import React from 'react'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { alpha } from '@mui/material/styles'

import { Text } from '@mxenabled/mxui'
import { SavingsIcon } from '@mxenabled/mx-icons'

import type { StepChartBlockData } from '../../../../../core/types/InsightsInstanceSlotData'

import { getStepStyles } from '../utils'

const LAST_STEP = 3
const STEP_INDICES = [0, 1, 2, 3] as const

const WithoutText = ({ slotData }: { slotData: StepChartBlockData }) => {
  const { completed_steps: completedSteps, label_1 } = slotData
  const allCompleted = completedSteps === LAST_STEP

  return (
    <Stack
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '8px',
        gap: 8,
        pb: 16,
        pt: 12,
        px: 16,
      }}
    >
      <Stack>
        <Text bold={true} variant="caption">
          {label_1}
        </Text>
      </Stack>
      <Box sx={{ display: 'grid', placeItems: 'center' }}>
        <Stack
          sx={(theme) => ({
            alignItems: 'center',
            bgcolor: alpha(theme.palette[allCompleted ? 'success' : 'primary'].main, 0.15),
            borderTopLeftRadius: '26px',
            borderBottomLeftRadius: '26px',
            gridArea: '1 / 1',
            height: 26,
            justifySelf: 'start',
            ml: -8,
            width: `${34 * completedSteps}%`,
          })}
        />
        <Stack sx={{ height: 36, gridArea: '1 / 1' }}>
          <Stack sx={{ alignItems: 'center', flexDirection: 'row' }}>
            {STEP_INDICES.map((index) => {
              const completed = index < completedSteps

              return (
                <React.Fragment key={index}>
                  {completedSteps === index ? (
                    <Stack
                      sx={{
                        alignItems: 'center',
                        bgcolor: allCompleted ? 'success.main' : 'primary.main',
                        borderRadius: '99999px',
                        height: 36,
                        p: 8,
                        width: 36,
                      }}
                    >
                      <SavingsIcon filled={true} sx={{ color: 'primary.contrastText' }} />
                    </Stack>
                  ) : (
                    <Box sx={(theme) => getStepStyles(theme, completed, allCompleted).dot} />
                  )}
                  {index !== LAST_STEP && (
                    <Box sx={(theme) => getStepStyles(theme, completed, allCompleted).connector} />
                  )}
                </React.Fragment>
              )
            })}
          </Stack>
        </Stack>
      </Box>
    </Stack>
  )
}

export default WithoutText
